function autoFormatAccountNumber(rawAccountNumber) {
  const digitsOnly = rawAccountNumber.replace(/[^0-9]/g, '')

  // 자동 추론 규칙: [시작 숫자] + [길이]
  const patterns = [
    { name: '카카오뱅크', match: /^3333[0-9]{13}$/, format: [4, 2, 7] },
    { name: '토스뱅크', match: /^1000[0-9]{12}$/, format: [4, 4, 4] },
    { name: '우리은행', match: /^1002[0-9]{13}$/, format: [4, 3, 6] },
    { name: '신한은행', match: /^110[0-9]{12}$/, format: [3, 3, 6] },
    { name: '국민은행', match: /^[0-9]{14}$/, format: [6, 2, 6] },
    // { name: '하나은행', match: /^[0-9]{14}$/, format: [3, 6, 5] },
    { name: '기업은행', match: /^[0-9]{12}$/, format: [3, 2, 7] },
    { name: 'SC제일', match: /^[0-9]{11}$/, format: [3, 2, 6] }
  ]

  for (let pattern of patterns) {
    if (pattern.match.test(digitsOnly)) {
      return applyHyphen(digitsOnly, pattern.format)
    }
  }

  // 추론 실패시 4자리 끊기
  return String(rawAccountNumber).replace(/(.{4})(.{4})/, '$1-$2-')
}

// 하이픈 적용 함수
function applyHyphen(digits, format) {
  let result = ''
  let index = 0

  for (let i = 0; i < format.length; i++) {
    if (index + format[i] > digits.length) break
    result += digits.substr(index, format[i])
    index += format[i]
    if (i < format.length - 1) result += '-'
  }

  // 남은 숫자 처리
  if (index < digits.length) {
    result += '-' + digits.substr(index)
  }

  return result
}

export default autoFormatAccountNumber
